import { gql } from '@apollo/client';

export const listOrganizations = gql`
  query listOrganizations($pagination: PaginationInput) {
    listOrganizations(pagination: $pagination) {
      id
      name
      membersCount
      archived
      subscription {
        id
        product {
          id
          catalogs {
            id
          }
        }
      }
    }
  }
`;
